import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { IDropDown } from '../../utils/iui-list-item';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@ngneat/transloco';
@Component({
    selector: 'app-drop-down',
    imports: [CommonModule, MatSelectModule, ReactiveFormsModule, MatInputModule, TranslocoModule],
    standalone:true,
    template: `

 <ng-container *transloco="let t">

    <div class="input-block">
      <mat-form-field
        appearance="fill"
        class="w-100"
        [ngClass]="{
      isReadonly: isReadonly,
      'open': isOpen,
      'close': !isOpen,
      'form-invalid-control': control?.invalid&&control?.dirty
    }"
      >
        <mat-label>{{ t(placeholder)}}
        @if(isRequired){
            <span class="required-star"><img src="../../../../assets/images/svgs/_required-star.svg"></span>
          }
        </mat-label>
     
        <mat-select
          class="mat-select"
          [disabled]="isDisabled"
          [formControl]="selectControl" 
          (selectionChange)="onSelectionChange($event)"
          (openedChange)="toggle($event)"
        >
          <mat-option
            *ngFor="let item of list; let i = index"
            [value]="item.id"
            class="option"
            [disabled]="bookedTimes.includes(item.name!)">
            {{ item.name }}
  
          </mat-option>

        </mat-select>

        @if(isRemove) {
          <img src="../../../../assets/images/svgs/_close_native.svg" class="close-icon">
        }
        <img src="../../../../assets/images/svgs/dropdown-arrow.svg" class="dropdown-icon">

      </mat-form-field>

    </div>
 </ng-container>

  `,
    styleUrl: './drop-down.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropDownComponent),
            multi: true,
        },
    ]
})
export class DropDownComponent implements  ControlValueAccessor {
  isOpen: boolean;
  toolTipDisplay: boolean;
  @Input() list: IDropDown[] = [];
  @Input() isDisabled: boolean;
  @Input() placeholder: string;
  @Input() isReadonly: boolean;
  @Input() control: any;
  @Input() bookedTimes: string[] = [];
  @Input() isRequired: boolean;
  @Input() isRemove: boolean;

  selectControl: FormControl = new FormControl();
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

  toggle(ev: boolean) {
    this.isOpen = ev;
  }


  writeValue(value: any): void {
    setTimeout(() => {
      this.selectControl.setValue(value);
      this.updateToolTip(value);
    }, 100);
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void { }

  private onModelChange: Function = (_: any) => { };

  onSelectionChange(item: any): void {
    this.onModelChange(item.value);
    this.selectionChange.emit(item.value);
    this.updateToolTip(item.value);
  }

  updateToolTip(value: any) {
    const selectedItem = this.list.find((x) => x.id === value);
  }
  setDisabledState(isDisabled: boolean) {
  }

  disableBookedTimes(item: any): boolean {
    if (item.name == '09:40') {
      return true
    }
    return false
  }


}
